<div class="flex flex-col min-h-screen bg-cover bg-center"
     style="background-image: url('assets/images/register-org/final-background.jpg');">
  <div class="flex-1 flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
    <div
      class="max-w-7xl w-full flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 ease-in-out">


      <!-- Left: Image -->
      <div
        class="hidden md:block w-1/2 bg-cover bg-center"
        style="background-image: url('assets/images/register-org/first.jpg');">
      </div>
      <!-- Right: Form -->
      <div class="w-full md:w-1/2 flex items-center justify-center p-6 bg-white">
        <div class="w-full max-w-xl">
          <!-- University Logo -->
          <div class="flex justify-center mb-4">
            <img src="assets/images/logo/arni-updated-logo.png" alt="Volmint Logo" class="h-12 md:h-16" />
          </div>

          <div class="mb-4 text-center md:text-left">
            <h2 class="text-2xl md:text-3xl font-bold  text-center text-gray-800 mb-1" *ngIf="formType === 'signIn'">
              Volmint - Scholarship Exam
            </h2>
          </div>

          <form [formGroup]="signInForm" class="space-y-2" *ngIf="formType === 'signIn'">
            <!-- Name -->
            <mat-form-field class="w-full mb-1" appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput placeholder="Enter name" formControlName="name" />
              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('name').hasError('required')">
                Name is required
              </small>
            </mat-form-field>

            <!-- Program -->
            <mat-form-field class="w-full mb-1" appearance="outline">
              <mat-label>Program</mat-label>
              <mat-select formControlName="program" (selectionChange)="getCourse()">
                <mat-option *ngFor="let program of programs" [value]="program?.program?.id">
                  {{ program?.program?.name }}
                </mat-option>
              </mat-select>
              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('program').hasError('required')">
                Program is required
              </small>
            </mat-form-field>

            <!-- Course -->
            <mat-form-field class="w-full mb-1" appearance="outline">
              <mat-label>Course</mat-label>
              <input type="text"
                     matInput
                     formControlName="searchKey"
                     [matAutocomplete]="auto">

              <mat-autocomplete #auto="matAutocomplete"
                                (optionSelected)="selectSearchSubject($event.option.value)"
                                [displayWith]="displaySubject">
                <mat-option *ngFor="let course of courses" [value]="course">
                  {{ course?.course?.name }}
                </mat-option>
              </mat-autocomplete>
              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('searchKey').hasError('required')">
                Program is required
              </small>
            </mat-form-field>


            <!-- Branch -->
            <mat-form-field *ngIf="showBranchField" class="w-full mb-1" appearance="outline">
              <mat-label>Branch</mat-label>
              <input type="text"
                     matInput
                     formControlName="branchSearchKey"
                     [matAutocomplete]="branchAuto">

              <mat-autocomplete #branchAuto="matAutocomplete"
                                (optionSelected)="selectBranch($event.option.value)"
                                [displayWith]="displayBranch">
                <mat-option *ngFor="let branch of branches" [value]="branch">
                  {{ branch?.branch?.name }}
                </mat-option>
              </mat-autocomplete>

              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('branch').hasError('required')">
                Branch is required
              </small>
            </mat-form-field>


            <!-- Email -->
            <mat-form-field class="w-full mb-1" appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Enter Email" formControlName="email" />
              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('email').hasError('required')">
                Email is required
              </small>
            </mat-form-field>

            <!-- Contact + OTP -->
            <div class="flex gap-2">
              <mat-form-field class="flex-1 mb-1" appearance="outline">
                <mat-label>Contact</mat-label>
                <input matInput type="number" formControlName="contact" placeholder="Enter Contact Number"
                       [readonly]="is_submitting" [disabled]="is_submitting" />
                <small class="text-red-500"
                       *ngIf="pageExtras['submitted'] && signInForm.get('contact').hasError('required')">
                  Contact is required
                </small>
              </mat-form-field>
              <button (click)="getOtp()" mat-raised-button class="bg-indigo-500 text-white py-2 rounded mt-2"
                      color="primary"
                      [disabled]="is_submitting">
                Verify
              </button>
            </div>

            <!-- OTP -->
            <mat-form-field *ngIf="showOtpField" class="w-full mb-1" appearance="outline">
              <mat-label>OTP</mat-label>
              <input matInput placeholder="Enter OTP" formControlName="otp" />
              <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('otp').hasError('required')">
                OTP is required
              </small>
            </mat-form-field>

            <!-- Aadhaar -->
            <mat-form-field class="w-full mb-1" appearance="outline">
              <mat-label>Aadhar Number</mat-label>
              <input matInput placeholder="Enter Aadhar Number" formControlName="aadhaar_number" />
              <small class="text-red-500"
                     *ngIf="pageExtras['submitted'] && signInForm.get('aadhaar_number').hasError('required')">
                Aadhar Number is required
              </small>
            </mat-form-field>
            <p class="text-sm text-gray-600" style="margin-top: -10px; margin-bottom: 15px">
              ⚠️ <strong>Note:</strong> Aadhar number will be used for verification. Please ensure accuracy.
            </p>

            <!-- DOB -->
            <mat-form-field class="w-full mb-2" appearance="outline">
              <mat-label>Date of Birth</mat-label>
              <input matInput placeholder="DD-MM-YYYY" formControlName="dob" />
              <small class="text-red-500" *ngIf="pageExtras['submitted'] && signInForm.get('dob').hasError('required')">
                Date of Birth is required
              </small>
            </mat-form-field>

            <button (click)="signIn()" mat-raised-button class="w-full bg-blue-600 text-white py-2 rounded"
                    color="primary">
              REGISTER
            </button>

            <p class="text-center text-gray-600 mt-3 text-sm">Already have an account? <br />
              <a class="text-blue-500 cursor-pointer hover:underline" (click)="goTo('auth/login')">Login here</a>
            </p>
          </form>
        </div>
      </div>


    </div>
  </div>
</div>

